import React from "react"
import { AnimatePresence, motion } from "framer-motion"
import { styled } from "@mui/material/styles"
import Modal from "@mui/material/Modal"
import AddIcon from "components/atoms/_icons/AddIcon"
import Fab from "components/atoms/Fab"
import { actionsWrapperVariants, actionVariants, fabVariants } from "components/atoms/SpeedDial/variants"
import withPremiumPermission from "components/HOCs/withPremiumPermission"

type Action = {
  key: string;
  icon: React.ReactNode;
  name: string;
  onClick: () => void;
}

type SpeedDialProps = {
  open: boolean;
  actions: Action[];
  onClose: () => void;
}

export default function SpeedDial(props: SpeedDialProps) {
  const { open, actions, onClose } = props

  function handleActionClicked(action: Action) {
    action.onClick()
  }

  return <>
    <Fab onClick={onClose}>
      <motion.div
        style={{
          width: "32px",
          height: "32px",
          background: "transparent !important"
        }}
        variants={fabVariants}
        animate={open ? "open" : "closed"}
      >
        <AddIcon/>
      </motion.div>
    </Fab>
    <Modal
      open={open}
      onClose={onClose}
      sx={{ zIndex: 11 }}
    >
      <div>
        <AnimatePresence>
          {open && (
            <ActionsWrapper
              key="actions"
              initial="closed"
              animate="open"
              exit="closed"
              variants={actionsWrapperVariants}
            >
              {actions.map((action: Action) => (
                <ActionWithPremiumPermission
                  key={action.key}
                  feature={action.key}
                  variants={actionVariants}
                  onClick={() => handleActionClicked(action)}
                >
                  {action.icon}
                  {action.name}
                </ActionWithPremiumPermission>
              ))}
            </ActionsWrapper>
          )}
        </AnimatePresence>
      </div>
    </Modal>
  </>
}

const ActionsWrapper = styled(motion.div)(() => ({
  display: "flex",
  flexDirection: "column-reverse",
  gap: "4px",
  position: "absolute",
  bottom: "0",
  left: "50%",
  transform: "translate(-50%, -70%)",
  marginBottom: "28px",
  zIndex: 20
}))

const Action = styled(motion.div)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "8px",
  borderRadius: "64px",
  backgroundColor: "#FFFFFF",
  color: theme.palette.gray["14"],
  fontSize: "1.2rem",
  padding: "11px 16px"
}))

const ActionWithPremiumPermission = withPremiumPermission(Action)
